import BaseBehavior from '../../foundation/base/base';

/* global CookieInformation */
/* global CookieConsent */

const COOKIE_CATEGORIES = [
	'cookie_cat_marketing',
	'cookie_cat_functional',
	'cookie_cat_statistic'
];

const consentGiven = category => CookieInformation.getConsentGivenFor(category);

class IFrame extends BaseBehavior {
	constructor(element) {
		super(element);
		this.element = element;
		this.initDomCache();

		this.iframe = this.element.querySelector('[data-js="iframe__iframe"]');
		this.iframeConsentSrc = this.iframe.getAttribute('data-consent-src');
		this.block = this.element.querySelector('[data-js="iframe__block"]');
		this.button = this.element.querySelector('[data-js="iframe__renew"]');

		this.ensureCookieInformationIsAvailable().then(() => {
			this.addEventListener();
		});
	}

	// eslint-disable-next-line class-methods-use-this
	ensureCookieInformationIsAvailable() {
		const timeout = 10000;
		const start = Date.now();
		// eslint-disable-next-line
		return new Promise(waitForCookieInfo);

		// waitForFoo makes the decision whether the condition is met
		// or not met or the timeout has been exceeded which means
		// this promise will be rejected
		function waitForCookieInfo(resolve, reject) {
			if (window.CookieInformation) {
				resolve(window.CookieInformation);
			} else if (timeout && (Date.now() - start) >= timeout) {
				// reject(new Error('timeout'));
				reject('Cookie information not ready in 10 seconds');
			} else {
				setTimeout(waitForCookieInfo.bind(this, resolve, reject), 100);
			}
		}
	}

	addEventListener() {
		if (CookieInformation) {
			window.addEventListener('CookieInformationConsentGiven', () => {
				this.checkCookieAccept();
			});
		}

		this.checkCookieAccept();
		this.button.addEventListener('click', () => {
			if (CookieConsent) {
				CookieConsent.renew();
			}
		});
	}

	checkCookieAccept() {
		const allAccepted = COOKIE_CATEGORIES.every(consentGiven);

		if (allAccepted) {
			this.loadIframe();
		} else {
			this.unloadIframe();
		}
	}

	loadIframe() {
		this.block.style.display = 'none';
		this.iframe.src = this.iframeConsentSrc;
	}

	unloadIframe() {
		this.iframe.src = '';
		this.block.style.display = 'inherit';
	}
}

export default IFrame;
